/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";

import {GameAssets} from "./GameAssets";
import {PunkGameConfig} from "./PunkGameConfig";

import {NormalWinPresentation} from "./presentations/features/win/normal/NormalWinPresentation";
import {BigWinPresentation} from "./presentations/features/win/bigwin/BigWinPresentation";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {IntroPresentation} from "./presentations/features/intro/IntroPresentation";
import {IdleWinPresentationManager} from "./presentations/features/idlewin/IdleWinPresentationManager";
import {IStillImageBgLoaderViewConfig} from "./gameloader/PunkGameLoaderView";
import {PunkBackground} from "./background/PunkBackground";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";

import {FeatureReelStopPresentation} from "./presentations/reel/feature/FeatureReelStopPresentation";
import {ReelStartPresentation} from "./presentations/reel/normal/ReelStartPresentation";
import {TotalWinPresentation} from "./presentations/features/totalWin/TotalWinPresentation";
import {ReelStopPresentation} from "./presentations/reel/normal/ReelStopPresentation";
import {ReelStoppedPresentation} from "./presentations/reel/normal/ReelStoppedPresentation";
import {ExpandingPresentation} from "./presentations/features/expanding/ExpandingPresentation";
import {RestorePresentation} from "./presentations/features/restore/RestorePresentation";
import {BonusIntroPresentation} from "./presentations/features/bonus/BonusIntroPresentation"

import {ReelAnimationManager} from "./presentations/independent/reelAnimator/ReelAnimationManager";
import {StateSymbolWin} from "./presentations/independent/symbol/StateSymbolWin";
import {XWaysCounter} from "./presentations/independent/countup/XWaysCounter";
import {PunkEngineManager} from "./punkEngine/PunkEngineManager"
import {ReelSlicedDivider} from "./presentations/independent/divider/ReelSlicedDivider";
import {JumpingWildController} from "./presentations/independent/jumpingWild/JumpingWildController";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {PosterManager} from "./presentations/independent/Poster/PosterManager";
import {Point} from "pixi.js";
import {ReelGraphicBackground} from "./presentations/independent/background/ReelGraphicBackground";
import {ReelItemOverlay} from "./presentations/independent/overlay/ReelItemOverlay";
import {SplashController} from "./presentations/independent/splashScreen/SplashController";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SoundConfig} from "./SoundConfig";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
// import { WinField } from "@nolimitcity/slot-game/bin/core/winpresentation/winfield/WinField";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {WinCounter} from "./presentations/independent/countup/WinCounter";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {PunkZeroController} from "./zerobet/PunkZeroController";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ResizeHelper} from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import {GameController} from "@nolimitcity/slot-game/bin/core/gamecontroller/GameController";
import {PunkServerDataParser} from "./server/PunkServerDataParser";
import {PunkParsedInitData} from "./server/data/PunkParsedInitData";
import {IPunkGameData, IPunkInitData} from "./server/data/PunkServerData";
import {PunkParsedGameData} from "./server/data/PunkParsedGameData";
import {REWinFieldController} from "./keypad/REWinFieldController";
import {FeaturePrice} from "./server/FeaturePrice";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {IGameData, IInitData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class PunkGameModuleConfig implements IGameModuleConfig {

    private static _instance:PunkGameModuleConfig = new PunkGameModuleConfig();
    public static get instance():PunkGameModuleConfig { return this._instance }

    private static resizeHelper:ResizeHelper = new ResizeHelper();

    public static xWayCounter:XWaysCounter;

    private static counterDisplayer:WinCounter;
    private static background:PunkBackground;
    private static posterManager:PosterManager;
    private static jumpWilds:JumpingWildController;
    private static reelItemOverlay:ReelItemOverlay;
    private static reelRowDivider:ReelSlicedDivider;
    private static splashController:SplashController;
    private static PunkEngineManager:PunkEngineManager;
    private static symbolWinPresentation:StateSymbolWin;
    private static reelAnimationArea:ReelAnimationManager;
    private static reelGraphicBackground:ReelGraphicBackground;
    public static featurePrice:FeaturePrice;

    GAME_CONFIG:IGameConfig = PunkGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = SoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = {};

    RESOURCES_CONFIG:IResourcesGroupConfig = GameAssets.RESOURCES_GROUPS;

    LOADER_VIEW:IStillImageBgLoaderViewConfig = {
        layer : PunkGameConfig.instance.LAYERS.INTRO.name,
        resourceGroup : ResourcesGroupName.INTRO,
        backgroundTextures : {
            desktop : {landscape : GameAssets.INTRO_BACKGROUND},
        },
        onButtonClickCallback : () => {},
        icons : [IntroFeatureLogo.X_WAYS, IntroFeatureLogo.VOLATILITY_HIGH]
    };

    // "@nolimitcity/slot-game": "0.42.3-SoundManager",
    // "@nolimitcity/slot-keypad": "1.2.12-SoundManager",
    // "@nolimitcity/slot-launcher": "1.2.16-SoundManager",
    // "@nolimitcity/promo-panel": "0.1.15.6-SoundManager"

    // INTRO_VIEW:(onClickCallback:() => void) => BlankSlotIntroView =
    //     (onClickCallback:() => void) => new BlankSlotIntroView({
    //         layer : BlankSlotGameConfig.instance.LAYERS.INTRO.name,
    //         onButtonClickCallback : onClickCallback,
    //         resourceGroup : ResourcesGroupName.INTRO,
    //         backgroundTextures : {
    //             desktop : {landscape : BlankSlotGameAssets.INTRO_BACKGROUND},
    //         },
    //         featureIcons : {
    //             icons : [IntroFeatureLogo.X_NUDGE, IntroFeatureLogo.X_WAYS, IntroFeatureLogo.VOLATILITY_HIGH]
    //         }
    //     });

    SERVER_PARSER:() => PunkServerDataParser = () => new PunkServerDataParser();

    PARSED_INIT_DATA:(data:IInitData, dataParser:ServerDataParser) =>
        PunkParsedInitData = (data:IInitData, dataParser:ServerDataParser) => new PunkParsedInitData(<IPunkInitData>data, <PunkServerDataParser>dataParser);

    PARSED_GAME_DATA:(data:IGameData, dataParser:ServerDataParser) =>
        PunkParsedGameData = (data:IGameData, dataParser:ServerDataParser) => new PunkParsedGameData(<IPunkGameData>data, <PunkServerDataParser>dataParser);

    GAME_CONTROLLER:() => GameController = () => {
        return new GameController({
            // checklog:true,
            // developerTools:false,
            // optimization:false,

            PRESENTATIONS : [
                {
                    eventType : SpinEvent.RESTORE,
                    presentations : [new RestorePresentation()]
                },
                {
                    eventType : SpinEvent.INTRO,
                    presentations : [new IntroPresentation()]
                },
                {
                    eventType : SpinEvent.IDLE,
                    presentations : [new IdleWinPresentationManager()]
                },
                {
                    eventType : SpinEvent.START,
                    presentations : [new ReelStartPresentation()]
                },
                {
                    eventType : SpinEvent.STOP,
                    presentations : [
                        new FeatureReelStopPresentation(),
                        new ReelStopPresentation()
                    ]
                },
                {
                    eventType : WinPresentationEvent.WIN_PRESENTATIONS_STARTED,
                    presentations : [
                        new ReelStoppedPresentation(),
                        new ExpandingPresentation(),
                        new NormalWinPresentation({
                            name : "WIN PRESENTATION",
                            layer : PunkGameConfig.instance.LAYERS.WIN_COUNT_UP.name
                        }),
                        new BigWinPresentation(),
                        new BonusIntroPresentation(),
                        new TotalWinPresentation(),
                    ]
                }]
        });
    }

    GAME_FEATURE_CREATOR:() => void = () => {
        PunkGameModuleConfig.PunkEngineManager = new PunkEngineManager(PunkGameConfig.instance.REEL_ENGINE_CONFIG);
        PunkGameModuleConfig.posterManager = new PosterManager();
        PunkGameModuleConfig.reelItemOverlay = new ReelItemOverlay();
        PunkGameModuleConfig.reelGraphicBackground = new ReelGraphicBackground();
        PunkGameModuleConfig.counterDisplayer = new WinCounter();

        PunkGameModuleConfig.background = new PunkBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : GameAssets.MAIN_GAME_BACKGROUND, offset : new Point(480, 520)}
            },
            stretch : false
        });

        PunkGameModuleConfig.reelAnimationArea = new ReelAnimationManager();
        PunkGameModuleConfig.symbolWinPresentation = new StateSymbolWin();
        PunkGameModuleConfig.xWayCounter = new XWaysCounter();
        PunkGameModuleConfig.reelRowDivider = new ReelSlicedDivider();
        PunkGameModuleConfig.jumpWilds = new JumpingWildController();

        PunkGameModuleConfig.splashController = new SplashController();

        PunkGameModuleConfig.featurePrice = new FeaturePrice();
    };

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new PunkZeroController(PunkGameConfig.instance.ZERO_BETS[0])
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController;
    WIN_FIELD:() => REWinFieldController = () => new REWinFieldController();

    constructor() {
        if(PunkGameModuleConfig.instance) {
            throw new Error("PunkGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
        PunkGameModuleConfig._instance = this;
    }
}